module.exports = __webpack_public_path__ + "static/media/selcare-white.3a6185be.png";